import DpInterestDetailsUseCase from "@domains/useCases/Reports/DpInterest/DpInterestDetails";
import DpInterestChargesUseCase from "@domains/useCases/Reports/DpInterest/DpInterestCharges";
export default (repositories) => {
    return {
        dpiDetails: new DpInterestDetailsUseCase(repositories.DpInterest),
        dpiCharges: new DpInterestChargesUseCase(repositories.DpInterest),
    };
};
